import styled from 'styled-components';
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

export const StyledNavigationMenuWrapper = styled.div`
  position: relative;
  z-index: 11;
`;

export const StyledNavigationMenu = styled.div`
  position: relative;
  display: block;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: ${contextualVariable.brandBgColor};
  z-index: 2;

  .hamburger-menu,
  .icon-clear {
    color: inherit;
  }
`;

export const StyledHamburgerButton = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};

  .main-nav__menu-btn {
    height: ${toRem(32)};
    width: ${toRem(32)};
    padding: 0;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: ${toRem(8)};
      font-size: ${toRem(24)};
    }
  }

  .main-nav__btn {
    border: 0;
    background-color: transparent;
    color: ${contextualVariable.brandFgColor};

    [class*='icon-']::before {
      display: block;
      padding: 0 ${toRem(4)};
    }
  }
`;

export const StyledActiveMenuContainer = styled.div`
  position: fixed;
  top: ${toRem(52)};
  left: 0;
  right: 0;
  min-height: ${toRem(56)};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${toRem(16)};
  border-bottom: ${toRem(1)} solid ${color.neutral20};
  background-color: ${color.base20};
  z-index: 50;

  @media ${baseVariables.mediaQuery.sm} {
    top: ${toRem(80)};
  }
`;

export const StyledActiveMenu = styled.div`
  text-align: center;
  font-size: ${toRem(18)};
  font-weight: ${font.fontWeightMedium};
  color: ${color.base10};
  line-height: 1;
  padding: 0;
  background-color: transparent;

  .property-name {
    font-size: ${toRem(22)};
    line-height: 1.25;
  }
`;

export const StyledMainMenu = styled.nav`
  display: none;
  position: fixed;
  top: ${toRem(52)};
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: calc(100vh - ${toRem(52)});
  background: ${color.base20};
  overflow: auto;
  z-index: 48;

  @media ${baseVariables.mediaQuery.sm} {
    top: ${toRem(80)};
    height: calc(100vh - ${toRem(80)});
  }

  &.open {
    display: block;
  }

  &.submenu-open {
    overflow: hidden;
  }
`;

export const StyledPropertyHeading = styled.div`
  padding: ${toRem(16)} ${toRem(0)};
  border-bottom: ${toRem(1)} solid ${color.neutral20};

  .property-heading-text {
    font-size: ${toRem(22)};
    font-weight: ${font.fontWeightRegular};
    line-height: 1.25;
    letter-spacing: 0;
    margin-bottom: ${toRem(8)};
    color: ${color.base10};
  }
`;

export const StyledMainMenuItems = styled.ul`
  margin: 0;
  padding: 0 ${toRem(16)};
  list-style: none;
`;

export const StyledMainMenuItem = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${toRem(14)} 0 ${toRem(10)};
  border-bottom: ${toRem(1)} solid ${color.neutral20};
  color: inherit;
  list-style-type: none;
  min-height: ${toRem(48)};
  a,
  button {
    display: block;
    width: 100%;
    text-align: left;
    margin: 0;
    padding: 0;
    border-bottom: 0;
    font-size: ${toRem(16)};
    font-weight: ${font.fontWeightRegular};
    color: ${color.base10};
    background: transparent;
    .sub-menu-toggler {
      position: absolute;
      right: ${toRem(24)};
      width: ${toRem(24)};
      height: ${toRem(24)};
      font-size: ${toRem(24)};
    }
    &:hover {
      font-weight: ${font.fontWeightRegular};
    }
  }
`;

export const StyledSubMenuWithBackCta = styled.div`
  display: none;
  background: ${color.base20};
  position: fixed;
  top: ${toRem(108)};
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 49;
  height: calc(100vh - ${toRem(108)});
  overflow-y: auto;

  &.open {
    display: block;
  }

  @media ${baseVariables.mediaQuery.sm} {
    top: ${toRem(136)};
    height: calc(100vh - ${toRem(136)});
  }

  .sub-menu-container {
    ul {
      padding: 0 ${toRem(16)};

      li {
        height: ${toRem(48)};
        border-bottom: none;
        padding: ${toRem(18)} 0;
        line-height: 1;
      }
    }
  }
`;

export const StyledBackCta = styled.button`
  width: ${toRem(24)};
  height: ${toRem(24)};
  position: absolute;
  z-index: 1;
  left: ${toRem(16)};
  top: 50%;
  transform: translateY(-50%);
  display: block;
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: ${color.base10};

  .icon-back-arrow-cropped,
  .icon-forward-arrow-cropped {
    font-size: ${toRem(18)};
    color: ${color.base10};
  }
`;
